<template>
  <!-- Pääsuvõtmed Kohustuslik (Süsteem → Turvalisus) and no key yet: the only
       page this session can open until a key is added. The akt app sends its
       users here too (?to=/akt/…). -->
  <v-app class="pkr">
    <main class="pkr-main">
      <img :src="logo" alt="Gaspre" class="pkr-logo" width="58" height="65">
      <h1 class="pkr-title">Lisa pääsuvõti</h1>
      <p class="pkr-lead">Intras on pääsuvõti nüüd kohustuslik. Lisa see seade, siis saad edasi minna. Edaspidi logid sisse sõrmejälje, näo või PIN-iga; parool üksi enam sisse ei lase.</p>
      <p class="pkr-lead"><b>Kasutad Intrat ka telefonis?</b> Lisa esimene võti telefoni: kas telefonis endas või arvutist nupuga „Lisa telefon QR-koodiga”. Telefoniga saad hiljem ka arvutis sisse logida.</p>
      <passkey-list @added="added" />
      <p class="pkr-out">Ei saa praegu? <a href="/auth/logout">Logi välja</a></p>
    </main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
import logo from '@/assets/gaspre-logo.png'
import PasskeyList from '@/components/PasskeyList.vue'
import loadArchivo from '@/plugins/archivo'

export default {
  components: { PasskeyList },
  data () {
    return { logo }
  },
  mounted () {
    loadArchivo()
  },
  methods: {
    ...mapActions(['isAuthenticated']),
    async added (data) {
      if (data.mustAdd) return
      await this.isAuthenticated(true)
      const to = String(this.$route.query.to || '/')
      // The akt app is another bundle: a full load, not a route of this one.
      if (to.startsWith('/akt')) {
        window.location.assign(to)
      } else {
        this.$router.replace(to.startsWith('/') ? to : '/').catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.pkr { background: #F4F6F5; color: #16322A; font-family: 'Archivo Variable', 'Archivo', 'Helvetica Neue', Helvetica, Arial, sans-serif; }
.pkr-main { width: 100%; max-width: 560px; margin: 0 auto; padding: 48px 24px; display: flex; flex-direction: column; gap: 20px; }
.pkr-logo { width: 58px; height: auto; }
.pkr-title { margin: 0; font-size: 30px; line-height: 1.1; font-weight: 700; font-stretch: 125%; }
.pkr-lead { margin: 0; font-size: 16px; color: #3E504A; }
.pkr-out { margin: 0; padding-top: 16px; border-top: 1px solid #C9D2CE; color: #3E504A; }
.pkr.v-application a { color: #2E7D32; font-weight: 600; }
</style>
